import { citiesCache } from "@/misc/httpCache";
import { get } from "./";
import { API_URL } from "@/misc/constants";
import { tInternalCity } from "@/types";

const base = API_URL + "/city";
const findBySlug = (slug: string) => {
  return get<tInternalCity>(`${base}/slug/${slug}`, { cache: citiesCache });
};
const getHighlighted = async () => {
  const { data } = await get<tInternalCity[]>(`${base}/searchable`, {
    cache: citiesCache,
  });
  return data;
};

const autocomplete = async ({ query }: { query: string }) => {
  const { data } = await get<{ items: tInternalCity[] }>(
    `${base}/autocomplete`,
    {
      cache: citiesCache,
      params: {
        query,
      },
    },
  );
  return data;
};
const reverseGeocode = async ({ lat, lng }: { lat: number; lng: number }) => {
  const { data } = await get<{ items: tInternalCity[] }>(
    `${base}/reverseGeocode`,
    {
      cache: citiesCache,
      params: {
        lat,
        lng,
      },
    },
  );
  return data;
};

export const CitiesAPI = {
  findBySlug,
  getHighlighted,
  autocomplete,
  reverseGeocode,
};
